export const ROOT_PATH = '/';
export const LOGIN_PATH = '/login';
export const OAUTH_CALLBACK_PATH = '/oauth/callback';

export const NEW_PATH = 'new';
export const EDIT_PATH = 'edit';
export const DETAILS_PATH = 'info';

export const COMPANIES_PATH = '/companies';
export const COMPANIES_PATH_NEW = '/companies.new';
export const COMPANY_PATH = ':companyId';

export const USERS_PATH = 'users';
export const INVITE_PATH = 'invite';

export const EMPLOYEES_PATH = '/employees';
export const EMPLOYEES_PATH_NEW = '/employees.new';
export const EMPLOYEE_PATH = ':employeeId';
export const ACCOUNT_PATH = 'account';
export const ENTITY_GIFTS_PATH = 'gifts';
export const DEPENDANTS_PATH = 'dependants';
export const IMPORT_PATH = 'import';
export const IMPORT_LIST_PATH = 'roster';
export const IMPORT_LIST_PATH_NEW = 'roster.new';

export const LOGS_PATH = '/logs';
export const LOGS_PATH_NEW = '/logs.new';

export const EVENTS_PATH = '/events';
export const HOME_PATH = 'home';
export const HOME_PATH_NEW = 'home.new';
export const OFFICE_PATH = 'office';
export const OFFICE_PATH_NEW = 'office.new';
export const SKIPPED_PATH = 'skipped';
export const SKIPPED_PATH_NEW = 'skipped.new';

export const NEW_HIRES_PATH = 'new-hires';
export const NEW_HIRES_PATH_NEW = 'new-hires.new';
export const ONE_OFF_PATH = 'one-off';
export const ONE_OFF_PATH_NEW = 'one-off.new';
export const CLIENT_ONE_OFF_PATH = 'client-one-off';
export const CLIENT_ONE_OFF_PATH_NEW = 'client-one-off.new';

export const GIFTS_PATH = '/gifts';
export const GIFT_PATH = ':giftId';
export const SUBSCRIPTIONS_PATH = 'subscriptions';
export const SUBSCRIPTIONS_PATH_NEW = 'subscriptions.new';
export const ORPHAN_PATH = 'orphan';
export const ORPHAN_PATH_NEW = 'orphan.new';

export const SHIPMENTS_PATH = '/shipments';
export const SHIPMENTS_PATH_NEW = '/shipments.new';
export const SHIPMENT_PATH = ':shipmentId';
export const SET_FOR_PICKUP_PATH = 'pickup';
export const SET_FOR_PICKUP_PATH_NEW = 'pickup.new';
export const TRACKING_PATH = 'tracking';
export const TRACKING_PATH_NEW = 'tracking.new';

export const GIFT_PACKAGES_PATH = 'packages';
export const GIFT_PACKAGES_PATH_NEW = 'packages.new';
export const PACKAGE_PATH = ':packageId';

export const GIFT_PRODUCTS_PATH = 'products';
export const GIFT_PRODUCTS_PATH_NEW = 'products.new';
export const PRODUCT_PATH = ':productId';

export const REPORTS_PATH = 'reports';
